import { render } from "./ProductConfigurator.vue?vue&type=template&id=483c85c2"
import script from "./ProductConfigurator.vue?vue&type=script&lang=js"
export * from "./ProductConfigurator.vue?vue&type=script&lang=js"

import "./ProductConfigurator.vue?vue&type=style&index=0&id=483c85c2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__